import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button } from '../../../../../../common/components/Button/Button';
import { Toolbar } from '../../../../../../common/components/Toolbar/Toolbar';
import Menu from '../../../../../../common/components/Menu/Menu';
import { MenuItem } from '../../../../../../common/components/MenuItem/MenuItem';
import { isMobile } from '../../../../../../common/services/isMobile';
import { BackButton } from '../../../../../../common/components/BackButton/BackButton';

export const titleStyle = {
  fontWeight: 700,
  margin: 0,
  fontSize: '20px',
};

function DemoEdgeControllerDetailsToolbar({
  edgeControllerId: edgeControllerIdProp = null,
  isFetching = false,
  pristine = true,
  submitting = false,
  readOnly = true,
  submit,
  backButtonHandler,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);

  const { edgeControllerId: urlEdgeControllerId } = useParams();
  const edgeControllerId = edgeControllerIdProp || urlEdgeControllerId;
  const title = edgeControllerId;

  const handleSave = () => {
    if (!isFetching && !pristine && !submitting) {
      submit();
    }
  };

  const handleReboot = () => {
    // TODO: Implement reboot functionality
    console.log('Reboot Edge Controller:', edgeControllerId);
  };

  const handleTransfer = () => {
    // TODO: Implement Transfer functionality
    console.log('Transfer: ', edgeControllerId);
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <Toolbar>
      <div className="edge-controller-toolbar">
        <BackButton onClick={backButtonHandler} disabled={isFetching} title="Back To Edge Controllers" />
        <h2 style={titleStyle}>{title}</h2>
        <div className="toolbar-separator" />
        <div className="edge-controller-toolbar__actions">
          {!isMobile && (
            <>
              <Button variant="contained" color="secondary" onClick={handleReboot} disabled={isFetching}>
                Reboot
              </Button>
              <Button variant="contained" color="secondary" onClick={handleTransfer} disabled={isFetching}>
                Transfer
              </Button>
            </>
          )}

          {isMobile && (
            <>
              <Button variant="contained" color="secondary" onClick={handleMenuOpen} disabled={isFetching}>
                Actions
              </Button>
              <Menu anchorEl={anchorEl} open={menuOpen} onClose={handleMenuClose}>
                <MenuItem
                  onClick={() => {
                    handleReboot();
                    handleMenuClose();
                  }}
                >
                  Reboot
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handleTransfer();
                    handleMenuClose();
                  }}
                >
                  Transfer
                </MenuItem>
              </Menu>
            </>
          )}

          {!readOnly && (
            <Button color="primary" onClick={handleSave} disabled={pristine || submitting || isFetching}>
              Submit Changes
            </Button>
          )}
        </div>
      </div>
    </Toolbar>
  );
}

export default DemoEdgeControllerDetailsToolbar;
